export default function ({ store, route, req }) {
    if (process.server && req.method === 'GET' && route.query['3rdParty'] && route.query.data) {
        const salt = 'M3JkcGFydHljb250cm9sc3N1Y2sh' // 3rdpartycontrolssuck! -- really simple/dumb 'security'
        const base64 = require('base-64')
        const rawData = route.query.data

        if (!rawData.includes(salt)) return

        const data = JSON.parse(base64.decode(rawData.replace(salt, '')))

        if (data) store.commit('cart/setThirdParty', data)
    }
}
